import React, { useState, useEffect, ReactElement } from "react";
import { ChevronDown } from "lucide-react";

interface NavGroupProps {
  icon: ReactElement<any, any>;
  label: string;
  isActive: boolean;
  children: React.ReactNode;
}

const NavGroup: React.FC<NavGroupProps> = ({ icon, label, isActive, children }) => {
  const [open, setOpen] = useState(isActive);

  useEffect(() => {
    if (isActive) setOpen(true);
  }, [isActive]);

  return (
    <li style={{ listStyle: "none" }}>
      <div
        className={`sidebar-item ${isActive ? "active" : ""}`}
        style={{ display: "flex", alignItems: "center", height: "40px", cursor: "pointer" }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span style={{ display: "inline-flex", alignItems: "center", width: "20px", height: "20px" }}>
          {React.cloneElement(icon, { style: { width: "20px", height: "20px", flexShrink: 0 } })}
        </span>
        <span style={{ marginLeft: "8px", flex: 1 }}>{label}</span>
        <ChevronDown
          size={14}
          style={{
            marginRight: "12px",
            transition: "transform 0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            color: "#999",
          }}
        />
      </div>
      {open && (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {children}
        </ul>
      )}
    </li>
  );
};

export default NavGroup;
